import React, { createContext, useContext } from "react"

const ModalContext = createContext()

export default ModalContext
/*
import React, { createContext, useContext, useState } from "react"

const ModalContext = createContext()
*/
